import { render, staticRenderFns } from "./LittleBuddhaSalesFormView.vue?vue&type=template&id=71db0594&"
import script from "./LittleBuddhaSalesFormView.vue?vue&type=script&lang=js&"
export * from "./LittleBuddhaSalesFormView.vue?vue&type=script&lang=js&"
import style0 from "./LittleBuddhaSalesFormView.vue?vue&type=style&index=0&id=71db0594&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports